enum LingoLiftDashboardSummaryType {
  watch = 'watch',
  learn = 'learn',
  speak = 'speak',
}

export { LingoLiftDashboardSummaryType };